var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Speak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25a18.86 18.86 0 00-12 4.33A18.86 18.86 0 0026 25c-6.39 0-14.21 6.82-18 13 7.15 11.77 20.12 15.7 29.76 15.83h.48C47.88 53.7 60.85 49.77 68 38c-3.79-6.18-11.61-13-18-13zm6 16H20v-4h36v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Speak.89a6b304.svg";
export { SvgH1Speak as ReactComponent };